'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _da_DK = require('../../date-picker/locale/da_DK');

var _da_DK2 = _interopRequireDefault(_da_DK);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _da_DK2['default'];